module.exports = __webpack_public_path__ + "img/stema.a7e72fbf.jpg";